import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { CoreInputsModule } from "@tmhcc-ng-lib/framwork/core-inputs";
import { DialogModule, DialogConfig } from "@tmhcc-ng-lib/framwork/dialog";
import { GridModule } from "@tmhcc-ng-lib/framwork/grid";
import { KnRSubjectivityComponent } from "./subjectivity.component";
import { PageHeaderModule } from "./../../shared/page-header/page-header.module";
import { QuotePolicyInfoModule } from "./../../shared/quote-policy-info/quote-policy-info.module";
import { SubjectivityService } from "@tmhcc/data-service";
import { PageTabInfoModule } from "./../../shared/page-tab/page-tab-info.module";
import { KnRSubjectivityDialogComponent } from "./subjectivity-dialog/subjectivity-dialog.component";


const routes: Routes = [{
  path: "account-setup/rating/quote-info-coverages/subjectivity",
  component: KnRSubjectivityComponent
}];

@NgModule({
  declarations: [KnRSubjectivityComponent, KnRSubjectivityDialogComponent],
  imports: [
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    CoreInputsModule,
    CommonModule,
    DialogModule,
    GridModule,
    PageHeaderModule,
    QuotePolicyInfoModule,
    PageTabInfoModule
  ],
  providers: [
    DialogConfig,
    SubjectivityService,
  ],  
  exports: [RouterModule]
})
export class KnRSubjectivityModule {}
